import React, { Component } from "react";
import styles from "assets/jss/material-kit-react/views/landingPage.js";
import { Send } from "@material-ui/icons";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
import classNames from "classnames";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import Axios from "../../../config/axios";
import { Skeleton } from "antd";
import { Divider } from "@material-ui/core";
import withErrorHandler from "../../../hoc/withErrorHandler";
import "../../../style.css";
import Loading from "components/Loading";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {
  suratKeterlambatanPembayaran,
  suratKehilangan,
} from "config/lettersId";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { suratPKL } from "config/lettersId";
import { suratMagang } from "config/lettersId";
import { suratUjianKhusus } from "config/lettersId";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

class RequestingLetter extends Component {
  state = {
    letter: {
      fields: [],
    },
    form: {},
    files: {},
    loading: true,
    loadingSubmit: false,
    error: {},
    fields_text: [],
    lecturer: [
      {
        name: "",
        type: "",
      },
    ],
    internship_member: [
      {
        name: "",
        nim: "",
      },
    ],
    thesis_detail: {
      participants: "",
      type: "Seminar Proposal",
      media: "",
      absenteeism: "",
      sign_date: "",
    },
    lost_letter: "",
    late_payment: "Mahasiswa semester lanjut",
    late_payment_file: "",
    lectureres_search: [],
    pkl: "pribadi",
  };

  componentDidMount() {
    this.fetchLetter();
  }

  fetchLetter = () => {
    Axios.get("/letters/" + this.props.match.params.id).then((response) => {
      let fields_text = response.data.fields.filter((field) =>
        ["text", "textarea"].includes(field.field_type)
      );
      this.setState({ letter: response.data, loading: false, fields_text });
    });
  };

  handleChangeForm = (e) => {
    let form = { ...this.state.form };
    form[e.target.name] = e.target.value;
    this.setState({ form, error: {} });
  };

  handleSendRequest = () => {
    if (this.state.letter._id === suratKehilangan && !this.state.lost_letter) {
      return;
    }

    // if([suratPKL, suratMagang].includes(this.state.letter._id) && this.state.pkl === 'kelompok' && this.state.internship_member.length <=0) {
    //     return
    // }

    if (this.state.letter._id === suratKeterlambatanPembayaran) {
      if (
        this.state.late_payment === "Mahasiswa semester akhir" &&
        !this.state.late_payment_file
      )
        return;
    }

    this.setState({ loadingSubmit: true });
    var formData = new FormData();

    this.state.fields_text.forEach((key) => {
      if (["text", "textarea"].includes(key.field_type)) {
        if (
          key.name.includes("dosen") &&
          this.state.letter._id === suratUjianKhusus
        ) {
          formData.append(
            "fields_value[]",
            JSON.stringify(
              this.state.form[key._id]
                ? { field_id: key._id, value: this.state.form[key._id] }
                : { field_id: key._id, value: "-" }
            )
          );
        } else if (key.name.includes("tanggal") || key.name.includes("tgl")) {
          formData.append(
            "fields_value[]",
            JSON.stringify(
              this.state.form[key._id]
                ? { field_id: key._id, value: this.state.form[key._id] }
                : { field_id: key._id, value: new Date() }
            )
          );
        } else {
          formData.append(
            "fields_value[]",
            JSON.stringify(
              this.state.form[key._id]
                ? { field_id: key._id, value: this.state.form[key._id] }
                : {}
            )
          );
        }
      }
    });
    if (this.state.letter._id === suratKehilangan) {
      formData.append("lost_letter_type", this.state.lost_letter);
    }

    if ([suratPKL, suratMagang].includes(this.state.letter._id)) {
      formData.append("internship_type", this.state.pkl);
    }

    formData.append("requester", this.props.user.user_id);
    formData.append("letters_id", this.state.letter._id);
    formData.append("submitted_date", "1");
    this.state.letter.fields.forEach((field) => {
      if (field.field_type === "file") {
        formData.append("file_keys[]", field._id);
        formData.append("files", this.state.files[field._id]);
      }
    });

    if (
      this.state.letter.thesis ||
      this.state.letter.thesis_defence ||
      this.state.letter.thesis_submission
    ) {
      this.state.lecturer.forEach((lecturer) => {
        formData.append("doping_doji[]", JSON.stringify(lecturer));
      });
    }

    if (
      [suratPKL, suratMagang].includes(this.state.letter._id) &&
      this.state.pkl === "kelompok"
    ) {
      this.state.internship_member.forEach((member) => {
        formData.append("internship_member[]", JSON.stringify(member));
      });
    }

    if (this.state.letter.thesis) {
      formData.append(
        "thesis_detail",
        JSON.stringify(this.state.thesis_detail)
      );
    }

    if (this.state.letter._id === suratKeterlambatanPembayaran) {
      formData.append(
        "additional_late_payment_value",
        this.state.late_payment_file
      );
      formData.append(
        "additional_late_payment_value2",
        this.state.late_payment
      );
    }

    Axios.post("/requested-letters/save", formData)
      .then(() => {
        this.props.history.push({
          pathname: "/surat-saya",
          state: {
            message: "Pemohonan Surat Telah Diajukan",
          },
        });
      })
      .catch((error) => {
        this.setState({ error: error.data, loadingSubmit: false });
      });
  };

  handleChangeFile = (e) => {
    let { files } = this.state;
    files[e.target.name] = e.target.files[0];
    this.setState({ files });
  };

  handleChangeLatePaymentFile = (e) => {
    this.setState({ late_payment_file: e.target.files[0] });
  };

  handleChangeLecturer = (value, index, name) => {
    if (!value) return;

    let { lecturer } = this.state;
    lecturer[index][name] = `${
      value.front_degree ? value.front_degree + " " : ""
    }${value.full_name}${
      value.behind_degree ? ", " + value.behind_degree : ""
    }`;
    this.setState({ lecturer });
  };

  handleChangeLecturer2 = (name, value) => {
    if (!value) return;

    let form = { ...this.state.form };
    form[name] = `${value.front_degree ? value.front_degree + " " : ""}${
      value.full_name
    }${value.behind_degree ? ", " + value.behind_degree : ""}`;
    this.setState({ form, error: {} });
  };

  handleChangeInternshipMember = (value, index, name) => {
    if (!value) return;
    let { internship_member } = this.state;
    internship_member[index][name] = value;
    this.setState({ internship_member: [...internship_member] });
  };

  handleChangeLecturerCheckbox = (index, value) => {
    let { lecturer } = this.state;
    lecturer[index].type = lecturer[index].type === value ? "" : value;
    this.setState({ lecturer });
  };

  handleAddLecturer = () => {
    let { lecturer } = this.state;
    lecturer.push({ name: "", type: "" });
    this.setState({ lecturer });
  };

  handleAddInternshipMember = () => {
    let { internship_member } = this.state;
    internship_member.push({ name: "", nim: "" });
    this.setState({ internship_member });
  };

  handleChangeThesisDetail = (val) => {
    let { thesis_detail } = this.state;
    thesis_detail.type = val;
    this.setState({ thesis_detail });
  };

  handleChangeLostLetter = (e) => {
    this.setState({ lost_letter: e });
  };

  handleChangeLatePayment = (e) => {
    this.setState({ late_payment: e, late_payment_file: "" });
  };

  handleChangePKL = (e) => {
    this.setState({ pkl: e });
  };

  handleSearchLecturer = async (e) => {
    const length = e.target.value.length;
    if (length > 2) {
      try {
        const response = await Axios.get(`/users/api?search=${e.target.value}`);
        this.setState({ lectureres_search: response.data.payload });
      } catch (error) {
        console.error(error);
      }
    }

    if (length <= 0) {
      this.setState({ lectureres_search: [] });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Parallax
          style={{ height: 200 }}
          filter
          image={require("assets/img/background.jpeg")}
        />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <div className={classes.section} style={{ paddingTop: 15 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <Skeleton
                    active={true}
                    loading={this.state.loading}
                    paragraph={0}
                  >
                    <h3 className={classes.title} style={{ color: "#000" }}>
                      {this.state.letter.title}
                    </h3>
                  </Skeleton>
                </GridItem>
              </GridContainer>
              <div style={{ marginTop: 40 }}>
                {[suratPKL, suratMagang].includes(this.state.letter._id) ? (
                  <div syle={{ marginBottom: 30 }}>
                    <GridContainer justify="center" style={{ marginTop: -20 }}>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={4}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={this.state.pkl === "pribadi"}
                          color="primary"
                          onChange={(e) => this.handleChangePKL("pribadi")}
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>Pribadi</span>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={4}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={this.state.pkl === "kelompok"}
                          color="primary"
                          onChange={(e) => this.handleChangePKL("kelompok")}
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>Kelompok</span>
                      </GridItem>
                    </GridContainer>
                  </div>
                ) : null}
                {this.state.letter._id === suratKeterlambatanPembayaran ? ( //Surat Kehilangan
                  <div syle={{ marginBottom: 30 }}>
                    <GridContainer justify="center" style={{ marginTop: -20 }}>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={4}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={
                            this.state.late_payment ===
                            "Mahasiswa semester lanjut"
                          }
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeLatePayment(
                              "Mahasiswa semester lanjut"
                            )
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>
                          Mahasiswa semester lanjut
                        </span>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={4}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={
                            this.state.late_payment ===
                            "Mahasiswa semester akhir"
                          }
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeLatePayment(
                              "Mahasiswa semester akhir"
                            )
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>
                          Mahasiswa semester akhir
                        </span>
                      </GridItem>
                    </GridContainer>
                  </div>
                ) : null}
                {this.state.letter._id === suratKehilangan ? ( //Surat Kehilangan
                  <div syle={{ marginBottom: 30 }}>
                    <GridContainer justify="center" style={{ marginTop: -20 }}>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={2}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={
                            this.state.lost_letter ===
                            "Kartu Rencana Studi (KRS)"
                          }
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeLostLetter(
                              "Kartu Rencana Studi (KRS)"
                            )
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>KRS</span>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={2}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={
                            this.state.lost_letter === "Kartu Hasil Studi (KHS)"
                          }
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeLostLetter(
                              "Kartu Hasil Studi (KHS)"
                            )
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>KHS</span>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={2}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={
                            this.state.lost_letter ===
                            "Kartu Tanda Mahasiswa (KTM)"
                          }
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeLostLetter(
                              "Kartu Tanda Mahasiswa (KTM)"
                            )
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>KTM</span>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={2}
                        style={{ marginTop: 20 }}
                      >
                        <Checkbox
                          checked={this.state.lost_letter === "Transkrip"}
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeLostLetter("Transkrip")
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>Transkrip</span>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          success
                          inputProps={{
                            placeholder: "Kehilangan Lainnya",
                            name: "type",
                            value: ![
                              "Transkrip",
                              "Kartu Tanda Mahasiswa (KTM)",
                              "Kartu Rencana Studi (KRS)",
                              "Kartu Hasil Studi (KHS)",
                            ].includes(this.state.lost_letter)
                              ? this.state.lost_letter
                              : "",
                            onChange: (e) =>
                              this.handleChangeLostLetter(e.target.value),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                  </div>
                ) : null}

                {this.state.letter.thesis ? (
                  <div syle={{ marginBottom: 30 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={4}>
                        <Checkbox
                          checked={
                            this.state.thesis_detail.type === "Seminar Proposal"
                          }
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeThesisDetail("Seminar Proposal")
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>Seminar Proposal</span>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4}>
                        <Checkbox
                          checked={
                            this.state.thesis_detail.type === "Seminar Hasil"
                          }
                          color="primary"
                          onChange={(e) =>
                            this.handleChangeThesisDetail("Seminar Hasil")
                          }
                          name="type"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        <span style={{ color: "black" }}>Seminar Hasil</span>
                      </GridItem>
                    </GridContainer>
                  </div>
                ) : null}

                <GridContainer justify="center">
                  {this.state.fields_text.map((field, index) => {
                    if (field.field_type === "text") {
                      if (field.name === "program") {
                        return (
                          <GridItem xs={12} sm={12} md={4} key={field._id}>
                            <FormControl
                              className="makeStyles-underline-374"
                              style={{
                                minWidth: "100%",
                                marginTop: 11,
                                marginBottom: 5,
                              }}
                            >
                              <InputLabel
                                id="progra-select-label"
                                style={{ color: "#4caf50", fontSize: 14 }}
                              >
                                Program/Jenjang
                              </InputLabel>
                              <Select
                                id="program-select"
                                onChange={this.handleChangeForm}
                                name={field._id}
                                value={this.state.form[field._id] || ""}
                              >
                                <MenuItem value="D-III">D-III</MenuItem>
                                <MenuItem value="S1">S1</MenuItem>
                                <MenuItem value="S2">S2</MenuItem>
                                <MenuItem value="S3">S3</MenuItem>
                                <MenuItem value="Spesialis">Spesialis</MenuItem>
                                <MenuItem value="Profesi">Profesi</MenuItem>
                              </Select>
                            </FormControl>
                            <div style={{ marginTop: -8 }}>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "fields_value." + index + ".field_id"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        );
                      }

                      if (field.name.includes("dosen")) {
                        return (
                          <GridItem xs={12} sm={12} md={4} key={field._id}>
                            <Autocomplete
                              options={this.state.lectureres_search}
                              getOptionLabel={(option) =>
                                `${
                                  option.front_degree
                                    ? option.front_degree + " "
                                    : ""
                                }${option.full_name}${
                                  option.behind_degree
                                    ? ", " + option.behind_degree
                                    : ""
                                }`
                              }
                              onKeyUp={this.handleSearchLecturer}
                              renderInput={(params) => (
                                <TextField {...params} label="Nama Dosen" />
                              )}
                              noOptionsText={
                                <div>Min. 3 huruf untuk mencari</div>
                              }
                              onClose={() =>
                                this.setState({ lectureres_search: [] })
                              }
                              onChange={(_, value) =>
                                this.handleChangeLecturer2(field._id, value)
                              }
                              name={field._id}
                              style={{ marginTop: 11 }}
                              placeholder={
                                suratUjianKhusus === this.state.letter._id
                                  ? `Pilih '-' jika kosong`
                                  : "Pilih Dosen"
                              }
                            />
                            <div style={{ marginTop: -8 }}>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "fields_value." + index + ".field_id"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        );
                      }

                      if (
                        field.name.includes("tanggal") ||
                        field.name.includes("tgl")
                      ) {
                        return (
                          <GridItem xs={12} sm={12} md={4} key={field._id}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                style={{ width: "100%", marginTop: 11 }}
                                disableToolbar
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                label={field.label}
                                value={this.state.form[field._id]}
                                onChange={(val) =>
                                  this.handleChangeForm({
                                    target: {
                                      value: val,
                                      name: field._id,
                                    },
                                  })
                                }
                                KeyboardButtonProps={{
                                  "aria-label": "change date",
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </GridItem>
                        );
                      }

                      return (
                        <GridItem xs={12} sm={12} md={4} key={field._id}>
                          <CustomInput
                            success
                            labelText={field.label}
                            inputProps={{
                              placeholder: field.placeholder,
                              name: field._id,
                              value: this.state.form[field._id] || "",
                              onChange: this.handleChangeForm,
                            }}
                            formControlProps={{
                              fullWidth: true,
                              error: this.state.error[
                                "fields_value." + index + ".field_id"
                              ]
                                ? true
                                : false,
                            }}
                          />
                          <div style={{ marginTop: -20 }}>
                            <span className="error-message2">
                              {
                                this.state.error[
                                  "fields_value." + index + ".field_id"
                                ]
                              }
                            </span>
                          </div>
                        </GridItem>
                      );
                    } else if (field.field_type === "textarea") {
                      return (
                        <GridItem xs={12} sm={12} md={4} key={field._id}>
                          <CustomInput
                            success
                            labelText={field.label}
                            inputProps={{
                              placeholder: field.placeholder,
                              name: field._id,
                              value: this.state.form[field._id] || "",
                              onChange: this.handleChangeForm,
                              multiline: true,
                              rows: 4,
                            }}
                            formControlProps={{
                              fullWidth: true,
                              error: this.state.error[
                                "fields_value." + index + ".field_id"
                              ]
                                ? true
                                : false,
                            }}
                          />
                          <div style={{ marginTop: -20 }}>
                            <span className="error-message2">
                              {
                                this.state.error[
                                  "fields_value." + index + ".field_id"
                                ]
                              }
                            </span>
                          </div>
                        </GridItem>
                      );
                    }
                    return null;
                  })}
                </GridContainer>
                {[suratPKL, suratMagang].includes(this.state.letter._id) &&
                this.state.pkl === "kelompok" ? (
                  <div style={{ marginTop: 40 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={8}>
                        <Skeleton
                          active={true}
                          loading={this.state.loading}
                          paragraph={0}
                        >
                          <h4
                            className={classes.title}
                            style={{ color: "#000" }}
                          >
                            Anggota Kelompok
                          </h4>
                        </Skeleton>
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={6} sm={6} md={4}>
                        <Button onClick={this.handleAddInternshipMember}>
                          Tambah Anggota
                        </Button>
                      </GridItem>
                    </GridContainer>

                    {this.state.internship_member.map((member, index) => (
                      <div key={index} style={{ marginBottom: 50 }}>
                        <GridContainer justify="center">
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomInput
                              success
                              labelText="Nama"
                              inputProps={{
                                placeholder: "Nama Anggota",
                                name: "nama_anggota",
                                value:
                                  this.state.internship_member[index].name ||
                                  "",
                                onChange: (e) =>
                                  this.handleChangeInternshipMember(
                                    e.target.value,
                                    index,
                                    "name"
                                  ),
                              }}
                              formControlProps={{
                                fullWidth: true,
                                error: this.state.error[
                                  "fields_value." + index + ".field_id"
                                ]
                                  ? true
                                  : false,
                              }}
                            />
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "internship_member." + index + ".name"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomInput
                              success
                              labelText="NIM"
                              inputProps={{
                                placeholder: "NIM Anggota",
                                name: "nim_anggota",
                                value:
                                  this.state.internship_member[index].nim || "",
                                onChange: (e) =>
                                  this.handleChangeInternshipMember(
                                    e.target.value,
                                    index,
                                    "nim"
                                  ),
                              }}
                              formControlProps={{
                                fullWidth: true,
                                error: this.state.error[
                                  "fields_value." + index + ".field_id"
                                ]
                                  ? true
                                  : false,
                              }}
                            />
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "internship_member." + index + ".nim"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        </GridContainer>
                      </div>
                    ))}
                  </div>
                ) : null}
                {this.state.letter.thesis ? (
                  <div style={{ marginTop: 40 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={8}>
                        <Skeleton
                          active={true}
                          loading={this.state.loading}
                          paragraph={0}
                        >
                          <h4
                            className={classes.title}
                            style={{ color: "#000" }}
                          >
                            Dosen Pembimbing/Penguji
                          </h4>
                        </Skeleton>
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={6} sm={6} md={4}>
                        <Button onClick={this.handleAddLecturer}>
                          Tambah Dosen
                        </Button>
                      </GridItem>
                    </GridContainer>

                    {this.state.lecturer.map((lecturer, index) => (
                      <div key={index} style={{ marginBottom: 50 }}>
                        <GridContainer justify="center">
                          <GridItem xs={12} sm={12} md={4}>
                            <Autocomplete
                              options={this.state.lectureres_search}
                              getOptionLabel={(option) =>
                                `${
                                  option.front_degree
                                    ? option.front_degree + " "
                                    : ""
                                }${option.full_name}${
                                  option.behind_degree
                                    ? ", " + option.behind_degree
                                    : ""
                                }`
                              }
                              onKeyUp={this.handleSearchLecturer}
                              renderInput={(params) => (
                                <TextField {...params} label="Nama Dosen" />
                              )}
                              noOptionsText={
                                <div>Min. 3 huruf untuk mencari</div>
                              }
                              onClose={() =>
                                this.setState({ lectureres_search: [] })
                              }
                              onChange={(e, value) =>
                                this.handleChangeLecturer(value, index, "name")
                              }
                            />
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "doping_doji." + index + ".name"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        </GridContainer>
                        <GridContainer justify="space-between">
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Pembimbing"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Pembimbing"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Pembimbing
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Pembimbing I"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Pembimbing I"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Pembimbing I
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Pembimbing II"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Pembimbing II"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Pembimbing II
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Ketua Penguji"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Ketua Penguji"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Ketua Penguji
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Penguji"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Penguji"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Penguji
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={
                                lecturer.type ===
                                "Dosen Pembimbing/Ketua Penguji"
                              }
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Pembimbing/Ketua Penguji"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Pembimbing/Ketua Penguji
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "doping_doji." + index + ".type"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        </GridContainer>
                      </div>
                    ))}
                  </div>
                ) : null}
                {this.state.letter.thesis_defence ? (
                  <div style={{ marginTop: 50 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={8}>
                        <Skeleton
                          active={true}
                          loading={this.state.loading}
                          paragraph={0}
                        >
                          <h4
                            className={classes.title}
                            style={{ color: "#000" }}
                          >
                            Dosen Pembimbing/Penguji
                          </h4>
                        </Skeleton>
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={6} sm={6} md={4}>
                        <Button onClick={this.handleAddLecturer}>
                          Tambah Dosen
                        </Button>
                      </GridItem>
                    </GridContainer>

                    {this.state.lecturer.map((lecturer, index) => (
                      <div key={index} style={{ marginBottom: 50 }}>
                        <GridContainer justify="center">
                          <GridItem xs={12} sm={12} md={3}>
                            <Autocomplete
                              options={this.state.lectureres_search}
                              getOptionLabel={(option) =>
                                `${
                                  option.front_degree
                                    ? option.front_degree + " "
                                    : ""
                                }${option.full_name}${
                                  option.behind_degree
                                    ? ", " + option.behind_degree
                                    : ""
                                }`
                              }
                              onKeyUp={this.handleSearchLecturer}
                              renderInput={(params) => (
                                <TextField {...params} label="Nama Dosen" />
                              )}
                              noOptionsText={
                                <div>Min. 3 huruf untuk mencari</div>
                              }
                              onClose={() =>
                                this.setState({ lectureres_search: [] })
                              }
                              onChange={(e, value) =>
                                this.handleChangeLecturer(value, index, "name")
                              }
                            />
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "doping_doji." + index + ".name"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        </GridContainer>
                        <GridContainer justify="space-between">
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Ketua Penguji"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Ketua Penguji"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Ketua Penguji
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={
                                lecturer.type === "Penguji I/Penguji Tamu"
                              }
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Penguji I/Penguji Tamu"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Penguji I/Penguji Tamu
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={
                                lecturer.type === "Penguji II/Pembimbing"
                              }
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Penguji II/Pembimbing"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Penguji II/Pembimbing
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={
                                lecturer.type === "Penguji II/Pembimbing I"
                              }
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Penguji II/Pembimbing I"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Penguji II/Pembimbing I
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={
                                lecturer.type === "Penguji III/Pembimbing II"
                              }
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Penguji III/Pembimbing II"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Penguji III/Pembimbing II
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "doping_doji." + index + ".type"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        </GridContainer>
                      </div>
                    ))}
                  </div>
                ) : null}
                {this.state.letter.thesis_submission ? (
                  <div style={{ marginTop: 50 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={8}>
                        <Skeleton
                          active={true}
                          loading={this.state.loading}
                          paragraph={0}
                        >
                          <h4
                            className={classes.title}
                            style={{ color: "#000" }}
                          >
                            Dosen Pembimbing/Penguji
                          </h4>
                        </Skeleton>
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={6} sm={6} md={4}>
                        <Button onClick={this.handleAddLecturer}>
                          Tambah Dosen
                        </Button>
                      </GridItem>
                    </GridContainer>

                    {this.state.lecturer.map((lecturer, index) => (
                      <div key={index} style={{ marginBottom: 50 }}>
                        <GridContainer justify="center">
                          <GridItem xs={12} sm={12} md={3}>
                            <Autocomplete
                              options={this.state.lectureres_search}
                              getOptionLabel={(option) =>
                                `${
                                  option.front_degree
                                    ? option.front_degree + " "
                                    : ""
                                }${option.full_name}${
                                  option.behind_degree
                                    ? ", " + option.behind_degree
                                    : ""
                                }`
                              }
                              onKeyUp={this.handleSearchLecturer}
                              renderInput={(params) => (
                                <TextField {...params} label="Nama Dosen" />
                              )}
                              noOptionsText={
                                <div>Min. 3 huruf untuk mencari</div>
                              }
                              onClose={() =>
                                this.setState({ lectureres_search: [] })
                              }
                              onChange={(e, value) =>
                                this.handleChangeLecturer(value, index, "name")
                              }
                            />
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "doping_doji." + index + ".name"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        </GridContainer>
                        <GridContainer justify="space-between">
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Pembimbing"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Pembimbing"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Pembimbing
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Pembimbing I"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Pembimbing I"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Pembimbing I
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Pembimbing II"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Pembimbing II"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Pembimbing II
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Ketua Penguji"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Ketua Penguji"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Ketua Penguji
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Penguji I"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Penguji I"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Penguji I
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Penguji II"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Penguji II"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Penguji II
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Penguji III"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Penguji III"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Penguji III
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Checkbox
                              checked={lecturer.type === "Dosen Penguji IV"}
                              color="primary"
                              onChange={(e) =>
                                this.handleChangeLecturerCheckbox(
                                  index,
                                  "Dosen Penguji IV"
                                )
                              }
                              name="type"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                            <span style={{ color: "black" }}>
                              Dosen Penguji IV
                            </span>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <div>
                              <span className="error-message2">
                                {
                                  this.state.error[
                                    "doping_doji." + index + ".type"
                                  ]
                                }
                              </span>
                            </div>
                          </GridItem>
                        </GridContainer>
                      </div>
                    ))}
                  </div>
                ) : null}
                {this.state.letter.fields.find(
                  (field) => field.field_type === "file"
                ) ? (
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={8}>
                      <Skeleton
                        active={true}
                        loading={this.state.loading}
                        paragraph={0}
                      >
                        <h4 className={classes.title} style={{ color: "#000" }}>
                          Upload Berkas
                        </h4>
                      </Skeleton>
                    </GridItem>
                  </GridContainer>
                ) : null}

                <GridContainer justify="center">
                  {this.state.letter.fields.map((field) => {
                    if (field.field_type === "file") {
                      return (
                        <GridItem
                          sm={12}
                          xs={12}
                          md={4}
                          key={field._id}
                          style={{ marginTop: 10 }}
                        >
                          <label>{field.label}</label>
                          <input
                            className="MuiButtonBase-root MuiButton-root MuiButton-contained"
                            style={{ background: "#4caf50", width: "100%" }}
                            type="file"
                            onChange={this.handleChangeFile}
                            name={field._id}
                          />
                          <div style={{ textAlign: "left", color: "#000" }}>
                            Ukuran file maks. 50 MB dan berekstensi PDF.{" "}
                          </div>
                        </GridItem>
                      );
                    }
                    return null;
                  })}
                  {this.props.match.params.id ===
                    suratKeterlambatanPembayaran &&
                  this.state.late_payment === "Mahasiswa semester akhir" ? (
                    <GridItem sm={12} xs={12} md={4} style={{ marginTop: 10 }}>
                      <label>Cover ACC Sidang Meja Hijau</label>
                      <input
                        className="MuiButtonBase-root MuiButton-root MuiButton-contained"
                        style={{ background: "#4caf50", width: "100%" }}
                        type="file"
                        onChange={this.handleChangeLatePaymentFile}
                        name="additional_late_payment_value"
                      />
                      <div style={{ textAlign: "left", color: "#000" }}>
                        Ukuran file maks. 50 MB
                      </div>
                    </GridItem>
                  ) : null}
                </GridContainer>
                <Divider style={{ marginTop: 50, marginBottom: 10 }} />
                <GridContainer justify="flex-end">
                  <GridItem md={4}>
                    <Button
                      onClick={this.handleSendRequest}
                      disabled={this.state.loadingSubmit}
                      round
                      color="primary"
                    >
                      Kirim Permohonan{" "}
                      <Send style={{ marginLeft: 10, color: "#FFFFFF" }} />
                    </Button>
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
        </div>

        <Loading loading={this.state.loadingSubmit} />
      </div>
    );
  }
}

RequestingLetter.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withErrorHandler(withStyles(styles)(RequestingLetter), Axios);
